export default "__VITE_ASSET__bf913306__"